import * as React from 'react';
import classNames from 'classnames';
import {Icon, IconType} from 'components/UIKit';
import styles from '../../ListingShare.scss';

export interface PopupDimensions {
  height: number;
  width: number;
}

type AnchorElementProps = JSX.IntrinsicElements['a'];

export interface SocialIconLinkProps extends AnchorElementProps {
  alt: string;
  link?: string;
  icon: IconType;
  platform?: string;
  iconSize?: number;
  popupDimensions?: PopupDimensions;
  onClick?: () => any;
}

const POPUP_WIDTH = 900;
const POPUP_HEIGHT = 500;

function getScreenDimensions(): {screenHeight: number; screenWidth: number} {
  if (window.hasOwnProperty('innerHeight')) {
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
    };
  }

  if (document && document.documentElement) {
    return {
      screenWidth: document.documentElement.clientWidth,
      screenHeight: document.documentElement.clientHeight,
    };
  }

  return {
    screenWidth: screen.width,
    screenHeight: screen.height,
  };
}

function getPopupDimensions(
  {height, width}: PopupDimensions = {height: POPUP_HEIGHT, width: POPUP_WIDTH},
) {
  const {screenHeight, screenWidth} = getScreenDimensions();

  const top = (screenHeight / 2) - (height / 2);
  const left = (screenWidth / 2) - (width / 2);

  return `height=${height}}, width=${width}, top=${top}, left=${left}`;
}

const GA_EVENT = 'social_share';

export class SocialIconLink extends React.Component<SocialIconLinkProps> {
  handleLinkClick = (event) => {
    const {onClick, link, popupDimensions} = this.props;

    if (onClick) {
      onClick();
      return;
    }

    if (!popupDimensions || !link) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    window.open(
      link,
      ' window',
      `toolbar=no, menubar=no, resizable=yes, ${getPopupDimensions(popupDimensions)}`,
    );
  };

  render() {
    const {
      alt,
      link,
      icon,
      iconSize,
      platform,
      className,
      popupDimensions,
      ...restProps
    } = this.props;

    const wrapperProps: any = {
      onClick: this.handleLinkClick,
      className: classNames(styles.IconWrap, className),
    };

    if (platform) {
      wrapperProps['data-ga-event'] = GA_EVENT;
      wrapperProps['data-ga-action'] = platform;
    }

    if (link) {
      wrapperProps.href = link;
    }

    const Wrapper = link ? 'a' : 'button';

    return (
      <Wrapper {...restProps} {...wrapperProps}>
        <Icon alt={alt} icon={icon} size={iconSize} />
      </Wrapper>
    );
  }
}

export default SocialIconLink;
